import FullWidthLayout from "../components/layout/FullWidthLayout";
import { connect } from "react-redux";

export function mapStateToProps(state) {
    return {
        bloombergSiteUrl: state.config.bloombergSiteUrl
    };
}

const FullWidthLayoutContainer = connect(
    mapStateToProps,
    () => ({})
)(FullWidthLayout);

export default FullWidthLayoutContainer;
